import { createIndexedDBStore } from '@/stores/_base/createIndexedDBStore'
import { createActiveOrderEncryptedService } from '@/services/order/activeOrderEncryptedService'
import type { OrderPenWithCommerce } from '@farmfree/common/types/order/orderPenWithCommerce'

const activeOrderService = createActiveOrderEncryptedService('admin')

export const useActiveOrderStore = createIndexedDBStore<OrderPenWithCommerce>({
  storeId: 'activeOrder',
  tableName: 'activeOrders',
  versionField: 'orderPenVersion',
  service: {
    getModified: (companyId: string, since: number) =>
      activeOrderService.getModified(companyId, since),
    getDeleted: (companyId: string) => activeOrderService.getDeleted(companyId),
    saveItem: (companyId: string, item: OrderPenWithCommerce) =>
      activeOrderService.saveItem(companyId, item),
    saveItems: (companyId: string, items: OrderPenWithCommerce[]) =>
      activeOrderService.saveItems(companyId, items),
    deleteItem: (companyId: string, id: string) => activeOrderService.deleteItem(companyId, id),
  },
  options: {
    debug: true,
  },
})
